import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import { COLORS } from '../../../constants/colors';
import { podcastThemeNamesMap } from '../../Article/ArticlePodcast/Mappings';
import PlayButton from '../../Global/PlayButton';

const Podcast = (props) => {
  const { data, special = false, type = 'standard' } = props;

  const {
    brand = '',
    guestName = '',
    headline = '',
    podcastCoverArt,
    podcastTheme = 'Courier Weekly',
    role = '',
    slug = '',
  } = data;

  let { main: background, text: color } = podcastThemeNamesMap[podcastTheme];

  // assign hex values
  background = COLORS[background];
  color = COLORS[color];

  const illustration = (
    <GatsbyImage
      alt="Podcast Illustration"
      image={getImage(podcastCoverArt)}
      style={{ height: '100%', width: '100%' }}
    />
  );
  const playButton = (
    <div className="podcast-play-button">
      <PlayButton background={color} color={background} />
    </div>
  );

  const callToAction = `Tune in to our conversation with ${
    brand || ''
  } ${role}, ${guestName}`;

  let podcast;
  if (type === 'long') {
    podcast = (
      <Link to={`/podcast/${slug}/`}>
        <div className="podcast" style={{ background, color }}>
          {!special && (
            <div className="podcast__left__content long">
              <div className="illustration">{illustration}</div>
            </div>
          )}

          <div className="podcast__right__content long">
            <div className="quote wrapper">
              <div className="quote" type={type}>
                {headline}
              </div>
            </div>
            {playButton}
            <div className="call-to-action">{callToAction}</div>
          </div>
        </div>
      </Link>
    );
    // Standard | Tall
  } else {
    podcast = (
      <Link to={`/podcast/${slug}/`}>
        <div className="podcast-content-card" style={{ background, color }}>
          <div className="quote wrapper">
            <div className="quote" type={type}>
              {headline}
            </div>
          </div>
          <div
            className={`illustration
              ${type === 'tall' ? 'flex' : 'none'}
          `}
          >
            {illustration}
          </div>
          {playButton}
          <div className="call-to-action">{callToAction}</div>
        </div>
      </Link>
    );
  }
  return podcast;
};

Podcast.propTypes = {
  data: PropTypes.shape({
    callToAction: PropTypes.string,
    podcastTheme: PropTypes.oneOf([
      'Courier Weekly',
      'Courier Workshop Weekly',
      'Courier Life',
    ]),
    quote: PropTypes.string,
  }),
  special: PropTypes.bool,
  type: PropTypes.oneOf(['standard', 'tall', 'long']),
};

export default Podcast;
